import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserCheck, UserX } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { useMode } from "../lib/mode";

export function SwitchSummary() {
  const mode = useMode();
  const [d, setD] = useState(null);
  useEffect(() => { if (mode?.mode === "local") api("/admin/switch-summary").then(setD).catch(() => setD(null)); }, [mode]);
  if (!d) return null;
  const out = d.users.filter((u) => !u.rientrato);
  const ins = d.users.filter((u) => u.rientrato);
  return (
    <div className="panel !p-6 mb-8 fade-up" data-testid="switch-summary">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-4">
        <h2 className="font-display text-xl font-bold text-[var(--navy)]">Riepilogo del passaggio</h2>
        <p className="text-sm text-slate-500">Passaggio del {fmtDate(d.switched_at, true)} · <b className="text-[var(--navy)]" data-testid="switch-summary-count">{d.rientrati} rientrati su {d.totale}</b></p>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden mb-5"><div className="h-full bg-[var(--teal)]" style={{ width: `${d.totale ? (d.rientrati / d.totale) * 100 : 0}%` }} /></div>
      <div className="grid md:grid-cols-2 gap-6">
        <div data-testid="switch-summary-out">
          <p className="text-xs uppercase tracking-wider font-semibold text-[var(--red)] mb-2 flex items-center gap-1"><UserX className="w-4 h-4" />Non ancora rientrati ({out.length})</p>
          {out.length === 0 ? <p className="text-sm text-slate-500">Tutti rientrati.</p> : out.map((u) => (
            <div key={u.id} className="flex justify-between text-sm py-1.5 border-b last:border-0" data-testid={`switch-out-${u.id}`}>
              <span className="text-[var(--navy)]">{u.nome}</span>
              <span className="text-xs text-slate-500">{u.password ? "ha la password" : "password non scelta"}</span>
            </div>))}
          {out.some((u) => !u.password) && <Link to="/admin/users" className="text-xs text-[var(--teal)] font-semibold mt-2 inline-block" data-testid="switch-summary-invite">Invia l'email "scegli la password" da Gestione personale</Link>}
        </div>
        <div data-testid="switch-summary-in">
          <p className="text-xs uppercase tracking-wider font-semibold text-emerald-700 mb-2 flex items-center gap-1"><UserCheck className="w-4 h-4" />Rientrati ({ins.length})</p>
          {ins.map((u) => (
            <div key={u.id} className="flex justify-between text-sm py-1.5 border-b last:border-0" data-testid={`switch-in-${u.id}`}>
              <span className="text-[var(--navy)]">{u.nome}</span><span className="text-xs text-slate-500">{fmtDate(u.last_login_at, true)}</span>
            </div>))}
        </div>
      </div>
    </div>
  );
}
